import { MarketViewType, SportId, VSportsBetStatus } from "./enum";
import {
    ladarBlueBetIds,
    ladarGameIds,
    powerballBlueBetIds,
    powerballGameIds,
    racingGameIds,
    racingBlueBetIds,
    ArteMainMarkets,
    SampleDomains,
} from "./constants";
import type { IMBet } from "./interfaces/mbet.interface";
import moment from "moment-timezone";
export const serialize = (obj: any, prefix?: string): any => {
    var str = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
            str.push(
                v !== null && typeof v === "object"
                    ? serialize(v, k)
                    : encodeURIComponent(k) + "=" + encodeURIComponent(v),
            );
        }
    }
    return str.join("&");
};

export function formatDateTimeZone(_date: any) {
    const date = moment(_date).local();
    return `${date.format("YYYY-MM-DD")}  ${date.format("HH:mm")}`;
}

export function formatOnlyDateTimeZone(_date: any) {
    const date = moment(_date).local();
    return `${date.format("MM-DD")}  ${date.format("HH:mm")}`;
}

export const getMainMarketIds = (sportId: number) => {
    let winlose_market_id = 0;
    let uo_market_id = 0;
    let handicap_market_id = 0;
    if (
        sportId == SportId.FOOT_BALL ||
        sportId == SportId.ICE_HOKEY ||
        sportId == SportId.HAND_BALL ||
        sportId == SportId.KABADDI ||
        sportId == SportId.HOCKEY ||
        sportId == SportId.RUGBY_LEAGUE ||
        sportId == SportId.FLOOR_BALL
    ) {
        winlose_market_id = 1;
        uo_market_id = 2;
        handicap_market_id = 3;
    } else if (
        sportId == SportId.BASKET_BALL ||
        sportId == SportId.BASE_BALL ||
        sportId == SportId.AUSTRALIAN_RULES ||
        sportId === SportId.AMERICAN_FOOTBALL
    ) {
        winlose_market_id = 226;
        uo_market_id = 28;
        handicap_market_id = 342;
    } else if (sportId == SportId.TENIS || sportId == SportId.CRICKET || sportId == SportId.AMERICAN_FOOTBALL) {
        winlose_market_id = 52;
        uo_market_id = 166;
        handicap_market_id = 201;
    } else if (
        sportId == SportId.VOLLEY_BALL ||
        sportId == SportId.BADMINTON ||
        sportId == SportId.EGAMES ||
        sportId == SportId.DARTS ||
        sportId == SportId.TABLE_TENIS
    ) {
        winlose_market_id = 52;
        uo_market_id = 2;
        handicap_market_id = 1558;
    } else if (sportId == SportId.BOXING) {
        winlose_market_id = 52;
        uo_market_id = 29;
    } else if (sportId == SportId.SNOOKER) {
        winlose_market_id = 52;
        uo_market_id = 1400;
        handicap_market_id = 3;
    }
    return { winlose_market_id, uo_market_id, handicap_market_id };
};

export const getCleanMarketId = (marketMode: MarketViewType, sportId: number) => {
    const { winlose_market_id, uo_market_id, handicap_market_id } = getMainMarketIds(sportId);
    if (marketMode == MarketViewType.WINNER) {
        return [winlose_market_id];
    } else if (marketMode == MarketViewType.UNDEROVER) {
        return [uo_market_id];
    } else if (marketMode == MarketViewType.HANDICAP) {
        return [handicap_market_id];
    } else {
        return [winlose_market_id, uo_market_id, handicap_market_id];
    }
};
/*
 *************** TABS MAPPING ***************
 */

// SPORTS PREMATCH
// > TABS - CATEGORIES
const prematchSportsTabs = {
    football: {
        1: { name: "Main", ids: [1, 3, 2, 13, 4, 415, 101, 102, 17, 34, 35, 16, 56, 98, 99] },
        2: { name: "Score", ids: [6, 128, 71, 5, 198, 199] },
        3: { name: "First-half", ids: [41, 64, 61, 21, 153, 155, 194, 196, 113, 72, 9] },
        4: { name: "Second-half", ids: [42, 65, 1693, 45, 154, 156, 92, 195, 197, 211, 73, 100] },
        5: { name: "Corner", ids: [80, 81, 95, 1552] },
        6: { name: "Special", ids: [19, 1841] },
    },
    basketball: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220, 4] },
        2: { name: "Score", ids: [51] },
        3: { name: "First-half", ids: [282, 53, 77, 354, 355, 62] },
        4: { name: "Second-half", ids: [] },
        5: { name: "1quarter", ids: [41, 64, 21, 72] },
        6: { name: "Special", ids: [16, 1332, 1328, 69] },
    },
    baseball: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220] },
        2: { name: "Score", ids: [51] },
        3: { name: "HALF", ids: [235, 281, 236, 2644, 2645] },
        4: { name: "1inning", ids: [41, 21, 237] },
        5: { name: "Special", ids: [16, 56, 846, 2040] },
    },
    ice_hockey: {
        1: { name: "Main", ids: [1, 3, 2, 13, 427, 101, 102] },
        2: { name: "Score", ids: [5, 198, 199, 6, 70] },
        3: { name: "1period", ids: [41, 64, 21, 2, 727] },
        4: { name: "Special", ids: [16, 56, 846, 2040] },
    },
    tennis: {
        1: { name: "Main", ids: [52, 201, 166, 165, 101, 102] },
        2: { name: "Score", ids: [5, 6] },
        3: { name: "1set", ids: [202, 64, 21, 9] },
        4: { name: "Special", ids: [] },
    },
    handball: {
        1: { name: "Main", ids: [1, 3, 2, 427, 101, 102, 4] },
        2: { name: "Score", ids: [71, 5] },
        3: { name: "First-half", ids: [41, 64, 21, 72] },
        4: { name: "Second-half", ids: [] },
        5: { name: "Special", ids: [] },
    },
    volleyball: {
        1: { name: "Main", ids: [52, 1558, 2, 165] },
        2: { name: "Score", ids: [5, 6] },
        3: { name: "1set", ids: [41, 64, 21, 72] },
        4: { name: "Special", ids: [] },
    },
    table_tennis: {
        1: { name: "Main", ids: [52, 1558, 2, 165] },
        2: { name: "Score", ids: [6] },
        3: { name: "1set", ids: [202, 64, 21, 9] },
        4: { name: "Special", ids: [] },
    },
    boxing: {
        1: { name: "Main", ids: [52, 29] },
        2: { name: "Special", ids: [] },
    },
    american_football: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220, 4] },
        2: { name: "Score", ids: [70, 51, 387, 388] },
        3: { name: "First-half", ids: [228, 53, 77] },
        4: { name: "Second-half", ids: [] },
        5: { name: `1quarter`, ids: [41, 64, 21] },
        6: { name: "Special", ids: [69] },
    },
    badminton: {
        1: { name: "Main", ids: [52, 1558, 2] },
        2: { name: "Special", ids: [] },
    },
    cricket: {
        1: { name: "Main", ids: [52] },
        2: { name: "Special", ids: [] },
    },
    darts: {
        1: { name: "Main", ids: [52] },
        2: { name: "Special", ids: [] },
    },
    hockey: {
        1: { name: "Main", ids: [1] },
        2: { name: "Special", ids: [] },
    },
    futsal: {
        1: { name: "Main", ids: [1, 2] },
        2: { name: "Special", ids: [] },
    },
    water_polo: {
        1: { name: "Main", ids: [1, 2] },
        2: { name: "Special", ids: [] },
    },
    snooker: {
        1: { name: "Main", ids: [52, 3] },
        2: { name: "Special", ids: [] },
    },
    floorball: {
        1: { name: "Main", ids: [1] },
        2: { name: "Special", ids: [] },
    },
    aussie_rules: {
        1: { name: "Main", ids: [52] },
        2: { name: "Special", ids: [] },
    },
    _default: {
        1: { name: "Main", ids: [] },
        2: { name: "Score", ids: [] },
        3: { name: "First-half", ids: [] },
        4: { name: "Second-half", ids: [] },
        5: { name: "quarter", ids: [] },
        6: { name: "Special", ids: [] },
    },
};

// SPORTS INPLAY
// > TABS - CATEGORIES
const inplaySportsTabs = {
    football: {
        1: { name: "Main", ids: [1, 3, 2, 13, 101, 102, 427, 415] },
        2: { name: "Score", ids: [17, 16, 128, 149, 150, 71, 5] },
        3: { name: "First-half", ids: [41, 64, 21, 113, 134] },
        4: { name: "Second-half", ids: [42, 65, 45, 211, 163] },
        5: { name: "Corner", ids: [80, 579, 81, 95, 11] },
        7: { name: "Special", ids: [59, 19] },
    },
    basketball: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220, 390] },
        2: { name: "Score", ids: [51] },
        3: { name: "First-half", ids: [63, 53, 77, 354, 355, 62] },
        4: { name: "Second-half", ids: [464, 468, 469, 1051, 1052, 529] },
        5: {
            name: "quarter",
            ids: [
                41, 64, 21, 153, 155, 72, 42, 65, 45, 154, 156, 73, 43, 66, 46, 223, 222, 74, 44, 67, 47, 287, 288, 75,
            ],
        },
        7: { name: "Special", ids: [69, 16, 56] },
    },
    baseball: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220] },
        2: { name: "Score", ids: [51] },
        3: { name: "HALF", ids: [235, 281, 236, 2644, 2645] },
        4: { name: "1inning", ids: [41, 21, 42, 45, 43, 46, 44, 47, 49, 48, 348, 352, 349, 353, 434, 436, 435, 437] },
        5: { name: "Special", ids: [69, 16, 56, 70, 846] },
    },
    ice_hockey: {
        1: { name: "Main", ids: [1, 3, 2, 101, 102] },
        2: { name: "Score", ids: [23, 22, 149, 150, 198, 199, 70, 128, 5, 6] },
        3: { name: "period", ids: [41, 64, 21, 9, 55, 72, 42, 65, 45, 100, 73, 43, 66, 46, 217, 74] },
        4: { name: "Special", ids: [16, 56, 59, 69] },
    },
    volleyball: {
        1: { name: "Main", ids: [52, 3, 1558, 164, 2] },
        2: { name: "Score", ids: [5, 6] },
        3: {
            name: "set",
            ids: [64, 21, 9, 72, 65, 45, 100, 73, 66, 46, 217, 74, 67, 47, 394, 75, 90, 68, 48, 395, 76],
        },
        4: { name: "Special", ids: [] },
    },
    american_football: {
        1: { name: "Main", ids: [226, 342, 28, 221, 220, 4] },
        2: { name: "Score", ids: [51, 70] },
        3: { name: "First-half", ids: [228, 53, 77] },
        4: { name: "Second-half", ids: [] },
        5: { name: "quarter", ids: [64, 21, 65, 45, 66, 46, 67, 47] },
        6: { name: "Special", ids: [69] },
    },
    _default: {
        1: { name: "Main", ids: [] },
        2: { name: "Score", ids: [] },
        3: { name: "First-half", ids: [] },
        4: { name: "Second-half", ids: [] },
        5: { name: "quarter", ids: [] },
        6: { name: "Special", ids: [] },
    },
};

// ESPORTS
// > TABS - CATEGORIES
const prematchEsportTabs = {
    dota_2: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [41, 64, 989, 692, 669, 672, 675, 666] },
        3: { name: "Special", ids: [] },
    },
    csgo: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [653, 64, 1120, 634] },
        3: { name: "Special", ids: [] },
    },
    league_of_legends: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202, 64, 989, 692, 669, 1251, 1165, 1133, 1129, 1165] },
        3: { name: "Special", ids: [1132, 1128] },
    },
    mobile_legends: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    valorant: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    arena_of_valor: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    warcraft_iii: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    starcraft: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    halo: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "1map", ids: [202] },
        3: { name: "Special", ids: [] },
    },
    _default: {
        1: { name: "Main", ids: [] },
        2: { name: "1map", ids: [] },
        3: { name: "Special", ids: [] },
    },
};
const inplayEsportTabs = {
    dota_2: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: {
            name: "realtime",
            ids: [202, 989, 72, 669, 672, 675, 666, 203, 990, 73, 670, 673, 677, 667, 204, 991, 74, 671, 674, 678, 668],
        },
        3: { name: "Special", ids: [] },
    },
    csgo: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [203, 64, 1120, 634, 203, 65, 1121, 635, 204, 66, 1122, 636] },
        3: { name: "Special", ids: [] },
    },
    league_of_legends: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: {
            name: "realtime",
            ids: [
                202, 989, 72, 669, 1251, 1165, 1133, 1129, 203, 990, 73, 670, 1252, 1166, 1134, 1130, 204, 991, 74, 671,
                1253, 1167, 1135, 1131,
            ],
        },
        3: { name: "Special", ids: [] },
    },
    mobile_legends: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    valorant: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    arena_of_valor: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    warcraft_iii: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    starcraft: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    halo: {
        1: { name: "Main", ids: [52, 3, 1536, 29] },
        2: { name: "realtime", ids: [202, 203, 204] },
        3: { name: "Special", ids: [] },
    },
    _default: {
        1: { name: "Main", ids: [] },
        2: { name: "realtime", ids: [] },
        3: { name: "Special", ids: [] },
    },
};

export const tabsMapping = {
    sports: {
        prematch: prematchSportsTabs,
        inplay: inplaySportsTabs,
        "prematch-cs": prematchSportsTabs,
        "prematch-sp": prematchSportsTabs,
    },
    esport: {
        prematch: prematchEsportTabs,
        inplay: inplayEsportTabs,
        "prematch-cs": prematchEsportTabs,
        "prematch-sp": prematchEsportTabs,
    },
};
export const sportTabsList = (sport: string, type: string, prematchInplay: string) => {
    const defaultTabs = [
        { id: 0, tab: "All", key: 0 },
        { id: 1, tab: "Main", key: 1 },
        { id: 2, tab: "Score", key: 2 },
        { id: 3, tab: "First-half", key: 3 },
        { id: 4, tab: "Second-half", key: 4 },
        { id: 5, tab: "Corner", key: 5 },
        { id: 6, tab: "Card", key: 6 },
        { id: 7, tab: "Special", key: 7 },
        { id: 8, tab: "Etc", key: 8 },
    ];

    const sportName = sport.toLowerCase().replace(":", "").replaceAll(" ", "_");
    const currentTabs = tabsMapping[type][prematchInplay] || {};
    if (Object.keys(currentTabs).includes(sportName)) {
        const tabs = Object.values(currentTabs[sportName]).map((tab, i) => ({
            id: i + 1,
            tab: tab.name,
            key: i + 1,
        }));
        return [defaultTabs[0]].concat(tabs);
    } else if ("_default" in tabsMapping[type][prematchInplay]) {
        const tabs = Object.values(tabsMapping[type][prematchInplay]["_default"]).map((tab, i) => ({
            id: i + 1,
            tab: tab.name,
            key: i + 1,
        }));
        return [defaultTabs[0]].concat(tabs);
    } else {
        return tabsMapping[type]?.[prematchInplay]?.["_default"] || defaultTabs;
    }
};

export const currencyFormat = (src: any) => {
    return Math.floor(Number(src)).toLocaleString("en-US");
};

export const floorNumber = (num: number) => {
    return Math.floor(num * 100) / 100;
};

export function isMarketDisabled(
    fixture: any,
    sportsType: string,
    marketIds: { winlose_market_id: number; uo_market_id: number; handicap_market_id: number },
) {
    const { winlose_market_id, uo_market_id, handicap_market_id } = marketIds;

    // INPLAY 상태 체크
    if (sportsType === "inplay") {
        if (fixture.Fixture.Status > 2 && fixture.Fixture.Status < 9) {
            return true;
        } else {
            const index = fixture.Markets.findIndex((x: any) => x.Id === winlose_market_id);
            if (index < 0) {
                return true;
            } else {
                return fixture.Markets[index].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
            }
        }
    }
    // PREMATCH 또는 CROSS 상태 체크
    else if (sportsType === "prematch" || sportsType === "cross") {
        // ABOUTTOSTART(9) 상태는 허용
        if (fixture.Fixture.Status > 1 && fixture.Fixture.Status < 9 && fixture.Fixture.Status !== 9) {
            return true;
        } else {
            // 농구(48242)와 야구(154914)의 경우 특별 처리
            if (fixture.Fixture.Sport.Id === SportId.BASKET_BALL || fixture.Fixture.Sport.Id === SportId.BASE_BALL) {
                // 농구/야구는 승패(226), 핸디캡(342), 오버언더(28) 마켓 확인
                const winIndex = fixture.Markets.findIndex((x: any) => x.Id === winlose_market_id);
                const handicapIndex = fixture.Markets.findIndex((x: any) => x.Id === handicap_market_id);
                const uoIndex = fixture.Markets.findIndex((x: any) => x.Id === uo_market_id);

                // 세 마켓 중 하나라도 있으면 그 마켓의 베팅 상태 확인
                if (winIndex >= 0) {
                    return fixture.Markets[winIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (handicapIndex >= 0) {
                    return fixture.Markets[handicapIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (uoIndex >= 0) {
                    return fixture.Markets[uoIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else {
                    return true; // 세 마켓 모두 없으면 비활성화
                }
            }
            // 배구(154830)의 경우 특별 처리
            else if (fixture.Fixture.Sport.Id === SportId.VOLLEY_BALL) {
                // 배구는 승패(52), 핸디캡(1558), 오버언더(2) 마켓 확인
                const winIndex = fixture.Markets.findIndex((x: any) => x.Id === winlose_market_id);
                const handicapIndex = fixture.Markets.findIndex((x: any) => x.Id === handicap_market_id);
                const uoIndex = fixture.Markets.findIndex((x: any) => x.Id === uo_market_id);

                // 세 마켓 중 하나라도 있으면 그 마켓의 베팅 상태 확인
                if (winIndex >= 0) {
                    return fixture.Markets[winIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (handicapIndex >= 0) {
                    return fixture.Markets[handicapIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (uoIndex >= 0) {
                    return fixture.Markets[uoIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else {
                    return true; // 세 마켓 모두 없으면 비활성화
                }
            }
            // 아이스하키(35232)의 경우 특별 처리
            else if (fixture.Fixture.Sport.Id === SportId.ICE_HOKEY) {
                // 아이스하키는 승무패(1), 핸디캡(3), 오버언더(2) 마켓 확인
                const winIndex = fixture.Markets.findIndex((x: any) => x.Id === winlose_market_id);
                const handicapIndex = fixture.Markets.findIndex((x: any) => x.Id === handicap_market_id);
                const uoIndex = fixture.Markets.findIndex((x: any) => x.Id === uo_market_id);

                // 세 마켓 중 하나라도 있으면 그 마켓의 베팅 상태 확인
                if (winIndex >= 0) {
                    return fixture.Markets[winIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (handicapIndex >= 0) {
                    return fixture.Markets[handicapIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else if (uoIndex >= 0) {
                    return fixture.Markets[uoIndex].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                } else {
                    return true; // 세 마켓 모두 없으면 비활성화
                }
            } else {
                // 다른 스포츠는 기존 로직 유지
                const index = fixture.Markets.findIndex((x: any) => x.Id === winlose_market_id);
                if (index < 0) {
                    return true;
                } else {
                    return fixture.Markets[index].Bets.findIndex((x: any) => x.Status === 1) < 0; // BetStatus.Open = 1
                }
            }
        }
    }
    return false;
}

export function betStatus(type: number) {
    if (type === 0) {
        return {
            text: "대기",
            style: "text-secondary",
        };
    } else if (type == 1) {
        return {
            text: "당첨",
            style: "text-[#00cf68]",
        };
    } else if (type == 2) {
        return {
            text: "미당첨",
            style: "text-[#d73333]",
        };
    } else if (type == 3) {
        return {
            text: "적특",
            style: "text-[#d73333]",
        };
    } else if (type == 6) {
        return {
            text: "취소",
            style: "text-[#d73333]",
        };
    } else if (type == 7) {
        return {
            text: "취소",
            style: "text-[#d73333]",
        };
    } else {
        // 정의되지 않은 상태값에 대한 기본값
        return {
            text: "알 수 없음",
            style: "text-secondary",
        };
    }
}

export const getBetMiniColor = (bet: IMBet) => {
    if (powerballGameIds.includes(bet.gameid)) {
        if (powerballBlueBetIds.includes(bet.betid)) {
            return "mini-blue-text";
        } else {
            return "mini-red-text";
        }
    } else if (ladarGameIds.includes(bet.gameid)) {
        if (ladarBlueBetIds.includes(bet.betid)) {
            return "mini-blue-text";
        } else {
            return "mini-red-text";
        }
    } else if (racingGameIds.includes(bet.gameid)) {
        if (bet.betid == 1 || bet.betid == 3) {
            return "mini-blue-text";
        } else if (bet.betid == 2 || bet.betid == 4) {
            return "mini-red-text";
        } else if (bet.betid == 5) {
            return "mini-red-text";
        } else if (bet.betid == 6) {
            return "mini-yellow-text";
        } else if (bet.betid == 7) {
            return "mini-blue-text";
        } else if (bet.betid == 8) {
            return "mini-green-text";
        }
    } else {
        console.error("unknow type", bet);
    }
};

export function dateOnly(num: any) {
    return num?.slice(0, 10);
}

export function convertToStars(value: string) {
    // Replace all but the last 4 characters with asterisks
    return "*".repeat(Math.max(value.length - 4, 0)) + value.substring(value.length - 4);
}

export function convertPhoneToStars(phone: string) {
    let start = 3;
    const country_code_index = phone.indexOf("82");
    if (country_code_index > -1) start += country_code_index + 2;
    return phone.substring(0, start) + "****" + phone.substring(phone.length - 4);
}

export const getStartOfMonth = (difference: number = 0) => {
    moment.tz.setDefault("Asia/Seoul");
    return moment().startOf("month").add(difference, "M").toDate();
};

export const getSportsNameFormId = (sport_id: number): string => {
    if (sport_id == SportId.FOOT_BALL) return "football";
    else if (sport_id == SportId.BASKET_BALL) return "basketball";
    else if (sport_id == SportId.BASE_BALL) return "baseball";
    else if (sport_id == SportId.VOLLEY_BALL) return "volleyball";
    else if (sport_id == SportId.ICE_HOKEY) return "hockey";
    else return "etc";
};

export const isShowThemeSelector = () => {
    const domain = window.location.host.replaceAll("www.", "");
    if (domain.includes("localhost") || domain.includes("127.0.0.1") || SampleDomains.includes(domain)) {
        return true;
    }
    return false;
};

export const getMaxBetWinAmount = (route: string, filteredBetSlips: any[], principal: any, totalOdds: number) => {
    let max_win = 0;
    let max_bet = 0;

    if (filteredBetSlips.length > 1) {
        // principal.sports_special_max_bet > 0 && (max_bet = principal.sports_special_max_bet);
        // principal.sports_special_max_win > 0 && (max_win = principal.sports_special_max_win);
        if (route.includes("/cross")) {
            max_bet = principal.sports_permission.cross_max_bet;
            max_win = principal.sports_permission.cross_max_win;
        } else if (route.includes("/special")) {
            max_bet = principal.sports_permission.special_max_bet;
            max_win = principal.sports_permission.special_max_win;
        } else if (route.includes("/inplay")) {
            max_bet = principal.sports_permission.inplay_max_bet;
            max_win = principal.sports_permission.inplay_max_win;
        } else {
            max_bet = principal.sports_permission.multi_max_bet;
            max_win = principal.sports_permission.multi_max_win;
        }
    } else if (filteredBetSlips.length == 1) {
        if (route.includes("inplay")) {
            max_bet = principal.sports_permission.inplay_max_bet;
            max_win = principal.sports_permission.inplay_max_win;
        } else {
            let index = ArteMainMarkets.findIndex((x) =>
                x.sports.includes(filteredBetSlips[0].Fixture.Fixture.Sport.Id),
            );
            if (index > -1 && ArteMainMarkets[index].markets.includes(filteredBetSlips[0].marketId)) {
                max_bet = principal.sports_permission.main_single_max_bet;
                max_win = principal.sports_permission.main_single_max_win;
            } else {
                max_bet = principal.sports_permission.other_single_max_bet;
                max_win = principal.sports_permission.other_single_max_win;
            }
        }
    } else {
        if (route.includes("inplay")) {
            max_bet = principal.sports_permission.inplay_max_bet;
            max_win = principal.sports_permission.inplay_max_win;
        } else {
            max_bet = principal.sports_permission.multi_max_bet;
            max_win = principal.sports_permission.multi_max_win;
        }
    }
    if (max_bet == 0) max_bet = Math.floor(max_win / totalOdds);
    console.log(max_bet, max_win);
    return { max_bet, max_win };
};

export const currencyFormatKorean = (value: number) => {
    return Math.floor(value / 10000) + "만";
};

/**
 * 쿠폰 유효기간 체크 함수
 * @param validTo 쿠폰 만료일 (ISO 문자열 또는 Date 객체)
 * @returns 유효기간이 만료되었으면 true, 아직 유효하면 false
 */
export const isCouponExpired = (validTo: string | Date | undefined | null): boolean => {
    if (!validTo) {
        // 유효기간이 설정되지 않은 경우 만료되지 않은 것으로 처리
        return false;
    }

    // 현재 시간 (서울 시간대)
    const now = moment().tz("Asia/Seoul");

    // 쿠폰 만료일 (서울 시간대로 변환)
    const expireDate = moment(validTo).tz("Asia/Seoul");

    // 현재 시간이 만료일을 지났는지 확인
    return now.isAfter(expireDate);
};

export const getVMarketName = (market_name: string) => {
    if (market_name == "wintielose") {
        return "승무패";
    } else if (market_name == "underover") {
        return "오버언더";
    } else if (market_name == "handicap") {
        return "핸디캡";
    } else {
        return market_name;
    }
};

export const getVBetStatus = (status: VSportsBetStatus) => {
    if (status == VSportsBetStatus.Pending) {
        return {
            text: "대기중",
            style: "text-ancent-500",
        };
    } else if (status == VSportsBetStatus.Win) {
        return {
            text: "당첨",
            style: "mini-blue-text",
        };
    } else if (status == VSportsBetStatus.Lost) {
        return {
            text: "낙첨",
            style: "mini-red-text",
        };
    } else if (status == VSportsBetStatus.Refund) {
        return {
            text: "환불",
            style: "mini-red-text",
        };
    }
};

export const getVBetName = (log: any) => {
    if (log.category == "Soccer") {
        if (log.marketname == "wintielose") {
            if (log.betname == 1) {
                return "승";
            } else if (log.betname == 2) {
                return "무";
            } else if (log.betname == 3) {
                return "패";
            }
        } else if (log.marketname == "underover") {
            if (log.betname == 1) {
                return "오버";
            } else if (log.betname == 2) {
                return "xxx";
            } else if (log.betname == 3) {
                return "언더";
            }
        }
    } else if (log.category == "Basketball") {
        if (log.marketname == "wintielose") {
            if (log.betname == 1) {
                return "승";
            } else if (log.betname == 2) {
                return "무";
            } else if (log.betname == 3) {
                return "패";
            }
        } else if (log.marketname == "underover") {
            if (log.betname == 1) {
                return "오버";
            } else if (log.betname == 2) {
                return "xxx";
            } else if (log.betname == 3) {
                return "언더";
            }
        } else if (log.marketname == "handicap") {
            if (log.betname == 1) {
                return "홈";
            } else if (log.betname == 2) {
                return "xxx";
            } else if (log.betname == 3) {
                return "원정";
            }
        }
    } else if (log.category == "Greyhounds") {
        return log.away;
    } else if (log.category == "Horse") {
        return log.away;
    }
};

export const getVWinAmount = (log: any) => {
    const { status, amount, odd } = log;
    if (status == VSportsBetStatus.Pending) {
        return 0;
    } else if (status == VSportsBetStatus.Win) {
        return currencyFormat(Number(amount) * Number(odd));
    } else if (status == VSportsBetStatus.Lost) {
        return 0;
    } else if (status == VSportsBetStatus.Refund) {
        return currencyFormat(amount);
    }
};

export const checkPoupCookie = (cookieName: string) => {
    let cookie = document.cookie;

    if (cookie.length > 0) {
        const startIndex = cookie.indexOf(cookieName);
        if (startIndex != -1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

/**
 * 크로스 마켓에서 마켓을 유지할지 결정하는 개선된 로직 (프론트엔드용)
 */
function shouldKeepMarketForCrossFrontend(market: any, openBetsCount: number, fixture: any): boolean {
    const sportId = fixture.Sport.Id;
    const leagueNameEn = fixture.League?.Name?.en || "";

    // 경기 시작까지 남은 시간 계산 (시간 단위)
    const now = new Date();
    const startTime = new Date(fixture.StartDate);
    const hoursUntilStart = (startTime.getTime() - now.getTime()) / (1000 * 60 * 60);

    console.log(
        `[shouldKeepMarketForCrossFrontend] 마켓 ID: ${market.Id}, 오픈 베팅: ${openBetsCount}개, 스포츠: ${sportId}, 리그: ${leagueNameEn}, 시작까지: ${hoursUntilStart.toFixed(1)}시간`,
    );

    // 1. 베팅이 2개 이상인 경우 항상 유지
    if (openBetsCount >= 2) {
        console.log(`베팅이 2개 이상이므로 유지`);
        return true;
    }

    // 2. 베팅이 0개인 경우 제거
    if (openBetsCount === 0) {
        console.log(`베팅이 0개이므로 제거`);
        return false;
    }

    // 3. 베팅이 1개인 경우 - 조건부 유지
    console.log(`베팅이 1개인 경우 조건 검사 시작`);

    // 3-1. 주요 리그는 베팅 1개라도 유지
    const majorLeagues = [
        "MLB",
        "KBO",
        "NPB",
        "CPBL", // 야구
        "NBA",
        "KBL",
        "CBA", // 농구
        "Premier League",
        "La Liga",
        "Serie A",
        "Bundesliga",
        "Ligue 1",
        "K League 1", // 축구
        "Champions League",
        "Europa League",
        "World Cup", // 국제 대회
    ];

    const isMajorLeague = majorLeagues.some((major) => leagueNameEn.toLowerCase().includes(major.toLowerCase()));

    if (isMajorLeague) {
        console.log(`주요 리그(${leagueNameEn})이므로 베팅 1개라도 유지`);
        return true;
    }

    // 3-2. 24시간 이내 시작하는 경기는 베팅 1개라도 유지
    if (hoursUntilStart <= 24 && hoursUntilStart >= 0) {
        console.log(`24시간 이내 시작 경기이므로 베팅 1개라도 유지`);
        return true;
    }

    // 3-3. 야구, 농구는 베팅 1개라도 유지 (크로스 마켓에서 중요한 스포츠)
    if ([154914, 48242].includes(sportId)) {
        // 야구, 농구
        console.log(`야구/농구 스포츠이므로 베팅 1개라도 유지`);
        return true;
    }

    // 3-4. 기타 조건에 해당하지 않으면 제거
    console.log(`조건에 해당하지 않으므로 제거`);
    return false;
}

export function filterMarkets(
    dataValue: any,
    marketFilterIdValue: number,
    tabsKeyPrimary: keyof typeof tabsMapping,
    tabsKeySecondary: keyof (typeof tabsMapping)[keyof typeof tabsMapping],
) {
    if (dataValue && dataValue.Markets) {
        let filteredMarkets;

        // 탭 필터링 적용
        if (marketFilterIdValue == 0) {
            filteredMarkets = dataValue.Markets;
        } else {
            const sportName = dataValue.Fixture.Sport.Name.en.toLowerCase().replace(":", "").replaceAll(" ", "_");
            const currentTabs = tabsMapping[tabsKeyPrimary][tabsKeySecondary] || {};
            if (Object.keys(currentTabs).includes(sportName)) {
                const marketIds = currentTabs[sportName][marketFilterIdValue].ids;
                filteredMarkets = dataValue.Markets.filter((x: any) => marketIds.includes(x.Id));
            } else {
                const marketIds = currentTabs["_default"][marketFilterIdValue].ids;
                filteredMarkets = dataValue.Markets.filter((x: any) => marketIds.includes(x.Id));
            }
        }

        // 크로스 마켓 뷰에서 개선된 마켓 필터링
        if (
            tabsKeySecondary === "prematch" &&
            tabsKeyPrimary === "sports" &&
            window.location.pathname.includes("/cross")
        ) {
            filteredMarkets = filteredMarkets.filter((market: any) => {
                // 오픈 상태인 베팅만 카운트 (BetStatus.Open = 1)
                const openBetsCount = market.Bets.filter((bet: any) => bet.Status === 1).length;

                // 개선된 필터링 로직 적용
                const shouldKeepMarket = shouldKeepMarketForCrossFrontend(market, openBetsCount, dataValue.Fixture);

                if (!shouldKeepMarket) {
                    console.log(`마켓 ID ${market.Id}의 오픈 베팅이 ${openBetsCount}개여서 제거합니다.`);
                    return false;
                }
                return true;
            });
        }

        return filteredMarkets;
    } else {
        console.log("empty value");
        return [];
    }
}
